var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgTypeWatch = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M2.39128 9.18591C3.57757 10.3653 5.64643 12 8.0002 12C10.354 12 12.4226 10.3653 13.6089 9.18591L13.6095 9.18536C13.9222 8.87445 14.0788 8.71881 14.1784 8.41349C14.2495 8.1956 14.2495 7.80439 14.1784 7.5865C14.0788 7.28117 13.9222 7.12551 13.6094 6.81457L13.6089 6.81407C12.4226 5.63472 10.354 4 8.0002 4C5.64643 4 3.57757 5.63472 2.39128 6.81407C2.07817 7.12535 1.9216 7.281 1.82194 7.5865C1.75086 7.80439 1.75086 8.1956 1.82194 8.41349C1.9216 8.71898 2.07815 8.87462 2.39123 9.18587L2.39128 9.18591Z",
  stroke: "white",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 8,
  cy: 8,
  r: 1.5,
  stroke: "white"
}))));
export default SvgTypeWatch;